export default __webpack_public_path__ + "static/media/001.f5b1abb0.jpg";